import * as React from "react";
import {cx}       from "emotion";
import {
    faAddressCard,
    faExternalLinkAlt,
    faLock,
    faPen,
    faShieldAlt,
}                                    from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}             from "@fortawesome/react-fontawesome";

import './user-management-card-mobile.scss';``

import {COMPANY_LEVEL, BRANCH_LEVEL} from "../../../../../common/logic/user-level";

export const UserCardMobile = ({user, userLevel, uniqueKey, routerHistory}) => (
    <div key={uniqueKey} className={cx("user-card-mobile-f7n1", user.agentNameFirst)}>
        <article xd-qa-type="card" xd-qa-name={user.idAgent} className={`item user-item ${!user.agentActive&&"inactive"}`}>
            <div className="left">
                {false /*user.headshot*/ ? (
                    <img src={user.headshot} alt={user.fullName} xd-qa-type="logo" xd-qa-name="User Headshot"/>
                ) : (
                    <div className="headshot-placeholder" xd-qa-type="text" xd-qa-name={mapFullNameAsInitials({agent: user})}>{mapFullNameAsInitials({agent: user})}</div>
                )}
            </div>
            <div className="right">
                <div className="user-info">
                    <h4 className="user-name" xd-qa-type="label" xd-qa-name="User Name">{user.fullName || user.agentEmail || user.agentLinkId || "User Name Missing"}</h4>

                    <div className="badges">
                        {user.loginLevel === COMPANY_LEVEL && <span xd-qa-type="badge" xd-qa-name="Company Admin" className="badge company-admin-badge">Company Admin</span>}
                        {user.loginLevel === BRANCH_LEVEL && <span xd-qa-type="badge" xd-qa-name="Office Admin" className="badge office-admin-badge">Office Admin</span>}
                        {!user.agentActive && <span xd-qa-type="badge" xd-qa-name="Inactive" className="badge inactive-badge">Inactive</span>}
                    </div>
                    {userLevel === COMPANY_LEVEL && <div
                        className="branch-name"
                        onClick={() => routerHistory.push('/account/admin/office?search=' + user.idBranch)}
                        xd-qa-type="link"
                        xd-qa-name="Office Name"
                    >
                        {user.branchName || "Office Name Missing"}
                    </div>}
                </div>

                <div className="ui">
                    <button aria-label="Edit User Info" xd-qa-type="button" xd-qa-name="Edit User Info" onClick={() => (
                        routerHistory.replace('/account/admin/user?modal=manage&agent=' + user.idAgent + '&menu=general')
                    )}><FontAwesomeIcon icon={faPen}/></button>
                    <button aria-label="Customization" xd-qa-type="button" xd-qa-name="Customization" onClick={() => (
                        routerHistory.replace('/account/admin/user?modal=manage&agent=' + user.idAgent + '&menu=customization')
                    )}><FontAwesomeIcon icon={faAddressCard}/></button>
                    <button aria-label="Security" xd-qa-type="button" xd-qa-name="Security" onClick={() => (
                        routerHistory.replace('/account/admin/user?modal=manage&agent=' + user.idAgent + '&menu=security')
                    )}><FontAwesomeIcon icon={faShieldAlt}/></button>
                    <button aria-label="Permissions" xd-qa-type="button" xd-qa-name="Permissions" onClick={() => (
                        routerHistory.replace('/account/admin/user?modal=manage&agent=' + user.idAgent + '&menu=permissions')
                    )}><FontAwesomeIcon icon={faLock}/></button>
                    <button aria-label="User Assets" xd-qa-type="button" xd-qa-name="User Assets" onClick={() => (
                        routerHistory.push('/account/admin/user-assets?agent=' + user.idAgent)
                    )}><FontAwesomeIcon icon={faExternalLinkAlt}/></button>
                </div>
            </div>
        </article>
    </div>
)


export const mapFullNameAsInitials = function({agent}): string
{
    return [agent?.agentNameFirst, agent?.agentNameMiddle, agent?.agentNameLast].filter(v => v).map(name => name[0]).join("");
};
